import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/imgs/logos_pc.png'


const _hoisted_1 = { id: "pc-app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, "Checkout", -1)
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "error" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img"
}, null, -1)

import Payment from "../../../components/checkstand/Payment.vue";
import Title from "../../../components/checkstand/Title.vue";
import BillingAddress from "./BillingAddress.vue";
import BasicInfo from "./BasicInfo.vue";
import OrderInfo from "../../../components/checkstand/OrderInfo.vue";
import { Row, Col } from "vant";
import { ref } from "vue";
import { getOrder, Rules } from "../../../tools/checkstand/checkstandOrder";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { order, payment, submit, basicRules, addressRules } = getOrder();

const addressVisible = ref(false);
function openAddress(value: boolean) {
  addressVisible.value = value;
}

const basicErrorMessage = ref("");
const basicErrorField = ref("");
const addressErrorMessage = ref("");
const addressErrorField = ref("");

function validateField(rs: Rules): [boolean, string, string] {
  let basicErrorMessage = "";
  let fieldPass = true;
  let errField = "";
  for (const key in rs) {
    const filedRules = rs[key];
    const filedValue = order[key];
    for (const rule of filedRules) {
      if (rule.required && String(filedValue || "").trim() === "") {
        fieldPass = false;
      } else if (rule.validator && !rule.validator(filedValue, rule)) {
        fieldPass = false;
      }
      if (!fieldPass) {
        basicErrorMessage = rule.message as string;
        break;
      }
    }
    if (!fieldPass) {
      errField = key;
      break;
    }
  }
  return [fieldPass, basicErrorMessage, errField];
}

const loading = ref(false);
async function submitForm() {
  // 不打开地址
  if (!addressVisible.value) {
    const [passed, message, basicFiled] = validateField(basicRules);
    basicErrorMessage.value = passed ? "" : message;
    basicErrorField.value = basicFiled;
    if (passed) {
      loading.value = true;
      try {
        submit();
      }catch (e){
        loading.value = false;
      }
    }
    addressErrorField.value = "";
    addressErrorMessage.value = "";
    // 打开地址
  } else {
    const [basicPassed, basicMessage, basicFiled] = validateField(basicRules);
    const [addressPassed, addressAddressMessage, addressFiled] = validateField(
      addressRules
    );
    basicErrorMessage.value = basicPassed ? "" : basicMessage;
    addressErrorMessage.value = addressPassed ? "" : addressAddressMessage;
    basicErrorField.value = basicFiled;
    addressErrorField.value = addressFiled;
    if (basicPassed && addressPassed) {
      loading.value = true;
      try {
        submit();
      }catch (e){
        loading.value = false;
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Payment, {
          class: "pay",
          paymentAmount: _unref(payment)
        }, null, 8, ["paymentAmount"]),
        _createVNode(_unref(Row), { type: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Col), null, {
              default: _withCtx(() => [
                _createVNode(Title, {
                  text: "Basic Information",
                  class: "title"
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Col), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(basicErrorMessage.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(BasicInfo, {
          class: "basic",
          "error-field": basicErrorField.value
        }, null, 8, ["error-field"]),
        _createVNode(_unref(Row), { type: "flex" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Col), null, {
              default: _withCtx(() => [
                _createVNode(Title, {
                  text: "The billing address is the same as the receiving address.",
                  class: "title",
                  open: "",
                  onChangeSwitch: openAddress
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Col), null, {
              default: _withCtx(() => [
                (addressVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(addressErrorMessage.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(BillingAddress, { "error-field": addressErrorField.value }, null, 8, ["error-field"]), [
          [_vShow, addressVisible.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(OrderInfo, {
          button: "",
          "order-no": _unref(order).BillNo,
          buttonCb: submitForm
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["order-no"])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          text: "Making"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})